export interface NonCriticalInitDeps {
  initSupport: () => Promise<void>;
  initPushNotifications: () => Promise<void>;
  initAnalytics: () => Promise<void>;
  initInAppPurchase: () => Promise<void>;
  reportError: (message: string, error?: unknown) => void;
}

// Non-critical SDK inits: fire-and-forget, outside runLocalInit's try/catch so they execute even
// when local init fails.
export const runNonCriticalInit = (deps: NonCriticalInitDeps): Promise<void> => {
  const sdkNames = ['Support', 'PushNotifications', 'Analytics', 'InAppPurchase'];
  return Promise.allSettled([
    deps.initSupport(),
    deps.initPushNotifications(),
    deps.initAnalytics(),
    deps.initInAppPurchase(),
  ]).then((results) => {
    results.forEach((result, i) => {
      if (result.status === 'rejected') {
        deps.reportError(`Non-critical SDK init failed: ${sdkNames[i]}`, result.reason);
      }
    });
  });
};
